<form [formGroup]="formGroup" class="tab-padding">
  @for (action of actionsFormArray?.controls; track $index) {
    <div class="accordions">
      <app-trigger-accordion [actionFormGroup]="action" [entity]="entity" [isDocusignEnabled]="isDocusignEnabled"></app-trigger-accordion>
    </div>
  }
  <!--  <div>{{ formGroup.value | json }}</div>-->
</form>
